import { observer } from 'mobx-react-lite';
import {
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@mui/material';
import type { DirectoryNode } from '../../../../types/admin/nodes';
import './FolderCard.scss';
import { useStores } from 'index';

type Props = {
  folder: DirectoryNode;
};

export const FolderCard = observer(({ folder }: Props) => {
  const { selectedIds, select, appendSelection, selectRangeTo, navigateTo } = useStores().mediaLibraryStore;
  const isSelected = selectedIds.has(folder.id);

  const handleClick = (e: React.MouseEvent) => {
    if (e.shiftKey) {
      selectRangeTo(folder.id);
    } else if (e.metaKey || e.ctrlKey) {
      appendSelection(folder.id);
    } else {
      select([folder.id]);
    }
  };

  const handleDoubleClick = () => navigateTo(folder.id);

  return (
    <Card
      className={`folder-card ${isSelected ? 'folder-card--selected' : ''}`}
      onClick={handleClick}
      onDoubleClick={handleDoubleClick}
    >
      <CardActionArea>
        <CardContent className="folder-card__content">
          <Typography variant="body2">
            {folder.name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
});
